import { analytics, User } from "../../../mp-database"
import CryptoJS from "crypto-js"
import { v7 as uuid } from "uuid"
import {
  EventAction,
  EventCategory,
  EventContentType,
  EventLabel,
  EventMetadata
} from "./types"
import { getEnv } from "../../../../utils/env"

const encryptionKey = getEnv("FIREBASE_ANALYTICS_SECRET_KEY")

export const faLogEvent = (
  category: EventCategory,
  action: EventAction,
  label: EventLabel,
  params = {}
) => {
  return analytics.logEvent(`${action}_${label}`, {
    category: category,
    ...params
  })
}

export const encryptValue = val => {
  const ciphertext = CryptoJS.AES.encrypt(val, encryptionKey)
  return ciphertext.toString()
}

export const decryptValue = val => {
  const _ciphertext = CryptoJS.AES.decrypt(val, encryptionKey)
  const originalText = _ciphertext.toString(CryptoJS.enc.Utf8)
  return originalText
}

export const mapUserRolesWithLabels = role => {
  switch (role) {
    case "Class":
      return EventLabel.CLASS
    case "School":
      return EventLabel.SCHOOL
    case "District":
      return EventLabel.DISTRICT
    case "Teacher":
      return EventLabel.TEACHER
    case "School Admin":
      return EventLabel.SCHOOL_ADMIN
    case "District Admin":
      return EventLabel.DISTRICT_ADMIN
    case "Super Administrator":
      return EventLabel.SUPER_ADMIN
    case "Course Author":
      return EventLabel.COURSE_AUTHOR
    case "Sales Rep":
      return EventLabel.SALES_REP
    case "Instructor":
      return EventLabel.INSTRUCTOR
    default:
      return EventLabel.STUDENT
  }
}

export const generateEventMetadata = (metadata: EventMetadata) => {
  const {
    eventAction,
    attempt,
    contentType,
    contentRefId,
    userId,
    userRole,
    score,
    timeSpent,
    program,
    subject,
    districtId,
    schoolId,
    classId,
    itemId
  } = metadata

  return {
    id: uuid(),
    attempt: attempt ?? 1,
    score: score ?? null,
    timeSpent: timeSpent ?? null,
    type: eventAction,
    contentType,
    contentRefId,
    url: window.location.href,
    userId,
    userRole,
    districtId,
    schoolId,
    classId,
    program,
    subject,
    date: new Date(),
    itemId: itemId ?? ""
  }
}

export const logEvent =
  (
    user: User,
    program: string,
    subject: string,
    category: EventCategory,
    label: EventLabel
  ) =>
  (
    eventAction: EventAction,
    contentType: EventContentType,
    contentRefId: string,
    metadata?: Partial<EventMetadata>
  ) => {
    faLogEvent(
      category,
      eventAction,
      label,
      generateEventMetadata({
        eventAction,
        contentType,
        contentRefId,
        userId: user?.id,
        userRole: user?.role,
        districtId: user?.schoolDistrict,
        schoolId: user?.school,
        classId: Object.keys(user?.classes ?? {}).find(
          key => user.classes?.[key]
        ),
        program,
        subject,
        ...(metadata ?? {})
      })
    )
  }
